export class DocumentCollectionRequest {
    public RecieveThrough: number;
    public CanJointRecieve: boolean;
    public PersonName: string;
    public PersonProofNumber: string;
    public PersonAddress: string;
    public IsHandovered: boolean;
    public CourierTrackingNo: string;
    public HandOveredOn:Date;
}